import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import ProductList from './component/ProductList'

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Shop All Designs | Wallscapes.AI</title>
        <meta name="description" content="Browse our collection of AI-generated art. Shop unique wall tapestries, posters, blankets, stickers, and more." />
      </Helmet>
      <Container>
        <Row>
          <ProductList />
        </Row>
      </Container >
    </>
  )
}

export default HomePage